import { useEffect, useState } from "react";
import { PopulationService } from "@services/engagements/population/populationService";
import { PopulationList } from "@models/population.model";

interface UsePopulationArgs {
  launchId: number | null;
  limit: number;
  offset: number;
  audienceId?: number | null;
  consumerId?: number | null;
  controlMode?: string | null;
  refreshKey?: number;
}

interface UsePopulationResult {
  data: PopulationList | null;
  loading: boolean;
  error: string | null;
}

export function usePopulation({ launchId, limit, offset, audienceId = null, consumerId = null, controlMode = null, refreshKey = 0 }: UsePopulationArgs): UsePopulationResult {
  const [data, setData] = useState<PopulationList | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (launchId === null || launchId < 0) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    new PopulationService()
      .getPopulation(launchId, limit, offset, audienceId, consumerId, controlMode)
      .then((result) => {
        if (cancelled) return;
        setData(result);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : "Failed to load population");
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [launchId, limit, offset, audienceId, consumerId, controlMode, refreshKey]);

  return { data, loading, error };
}
